import { render, staticRenderFns } from "./receiptShippingOrder.vue?vue&type=template&id=261273a2&scoped=true&"
import script from "./receiptShippingOrder.vue?vue&type=script&lang=js&"
export * from "./receiptShippingOrder.vue?vue&type=script&lang=js&"
import style0 from "./receiptShippingOrder.vue?vue&type=style&index=0&id=261273a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261273a2",
  null
  
)

export default component.exports